import type { TimelineItemType } from '@witmetrics/unison-core';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { classes, styles } from './utils';

export type TimelineToggleProps = {
  value: TimelineItemType;
  onChange: (value: TimelineItemType) => void;
};

export default function TimelineToggle({
  value,
  onChange,
}: TimelineToggleProps) {
  return (
    <ToggleBlock<TimelineItemType>
      className={classes.toggleBlock}
      value={value}
      onChange={onChange}>
      <ToggleOption sx={styles.option} className={classes.option} value="ALL">
        All
      </ToggleOption>
      <ToggleOption
        sx={styles.option}
        className={classes.option}
        value="KEYPOINTS">
        Keypoints
      </ToggleOption>
      <ToggleOption sx={styles.option} className={classes.option} value="NOTES">
        Notes
      </ToggleOption>
    </ToggleBlock>
  );
}
